module.exports = __webpack_public_path__ + "static/img/6.85da483.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/6.jpg
// module id = d3m0
// module chunks = 0